import React, { Fragment, useEffect, useMemo } from "react"
import { Listbox, Transition } from "@headlessui/react"
import { AiOutlineCheck } from "react-icons/ai"
import { TitleTranslation } from "utils/titleTranslater"
import { RiArrowDownSLine } from "react-icons/ri"
import { classNames } from "utils/classNames"
import { Filter } from "./style"
import { t } from "i18next"

const DropdownSelect = React.memo(
  ({
    setValue = () => {},
    options,
    inputBorderClassName = "",
    disabled,
    label,
    name,
    icon,
    value = {},
    language = false,
  }) => {
    const defaultLang = localStorage.getItem("lang")

    useEffect(() => {
      if (value) {
        const dataObj = options.find((item) => item?._id === value?._id)
        setValue(() => dataObj)
      }
      if (!value) {
        setValue({})
      }
    }, [])

    const defaultTitle = useMemo(() => {
      const titleLangs = {
        uz: "titleUZ",
        ru: "titleRU",
        en: "titleEN",
      }
      return titleLangs?.[defaultLang] || "title"
    }, [defaultLang])

    return (
      <Listbox
        value={value}
        onChange={(val) => setValue(name, val)}
        disabled={disabled}
        name={name}
      >
        <Filter
          className={classNames(
            name !== "year" ? "w-full" : "",
            "relative border-none text-sm leading-5 text-gray-900 focus:ring-0 focus:outline-none bg-transparent filter-input "
          )}
        >
          {label?.length && (
            <div className="pb-[8px] filter-label">
              <span>{label}</span>
            </div>
          )}
          <Listbox.Button
            className={classNames(
              inputBorderClassName || "shadow-md",
              name !== "year" ? "w-full" : "w-3/5",
              "flex gap-[16px] min-h-[45px] justify-between items-center relative cursor-default overflow-hidden rounded-lg px-4 py-3 bg-[#EBF2FA] text-left  focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm"
            )}
          >
            {icon && icon}
            <span className="block truncate">
              {language ? value?.[defaultTitle] : value?.title}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <RiArrowDownSLine
                size={24}
                className="text-[#595F62]"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-50 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {options.length === 0 ? (
                <div className="relative px-4 py-2 text-gray-700 cursor-default select-none">
                  {t("no-results")}
                </div>
              ) : (
                options.map((option) => (
                  <Listbox.Option
                    key={option?._id}
                    className={({ active }) =>
                      `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                        active ? "bg-[#2D2D2DE5] text-white" : "text-gray-900"
                      }`
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {option[TitleTranslation()] ?? option?.title}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-[#2D2D2DE5]"
                            }`}
                          >
                            <AiOutlineCheck
                              className="w-5 h-5"
                              aria-hidden="true"
                            />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))
              )}
            </Listbox.Options>
          </Transition>
        </Filter>
      </Listbox>
    )
  }
)

export default DropdownSelect
